import React, { useCallback, useState } from 'react';
import { ComponentProps } from './Tabs.types';
import Tab from './Tab';
import StyledTabs from './Tabs.styled';

const Tabs: React.FC<ComponentProps> = ({ activeTab = 0, config, children }) => {
  const [activeTabNumber, setActiveTabNumber] = useState<number>(activeTab);
  const tabPanelsCount = React.Children.count(children);

  const handleChange = (value: number) => () => {
    setActiveTabNumber(value);
  };

  const getTabPanel = useCallback(
    (activeTabNumber) => {
      return React.Children.toArray(children)[activeTabNumber];
    },
    [children],
  );

  return (
    <>
      <StyledTabs>
        {config.map((tabConfig, index: number) => {
          const { label, isDisabled, id } = tabConfig;

          return (
            <Tab
              key={id}
              label={label}
              onTabChange={handleChange(index)}
              isActive={activeTabNumber === index}
              isDisabled={isDisabled}>
              {label}
            </Tab>
          );
        })}
      </StyledTabs>

      {tabPanelsCount > 0 && <>{getTabPanel(activeTabNumber)}</>}
    </>
  );
};

export default Tabs;
